import { Routes } from '@angular/router';
import { MsalGuard } from '@azure/msal-angular';
import { HomeComponent } from './components/home/home.component';
import { UnauthorizedComponent } from './common/unauthorized/unauthorized.component';
import { authGuard } from './core/guards/auth.guard';
import { UserPermission } from './core/constants/app.constants';

export const routes: Routes = [
  {
    path: '',
    component: HomeComponent,
    canActivate: [MsalGuard],
    children: [
      {
        path: 'bic',
        canActivate: [authGuard],
        data: {
          permissions: [UserPermission.READ_ALL, UserPermission.EDIT_ALL],
        },
        loadChildren: () =>
          import('./features/best-in-class/bic.routes').then(
            (mod) => mod.BIC_ROUTES,
          ),
      },
      {
        path: '',
        redirectTo: '/bic/defaultSiteProfile',
        pathMatch: 'full',
      },
      {
        path: 'admin',
        canActivate: [authGuard],
        data: {
          permissions: [UserPermission.BIC_ADMIN],
        },
        loadChildren: () =>
          import('./features/one-customer-admin/admin.routes').then(
            (mod) => mod.ADMIN_ROUTES,
          ),
      },
    ],
  },
  { path: 'unauthorized', component: UnauthorizedComponent },
  {
    path: '**',
    redirectTo: '',
  },
  // ...other routes...
];
